import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const getVehicleMake = async (data) => {
  try {
    return await postRequest(urls.VEHICLE_MAKE, data);
  } catch (err) {
    return err;
  }
};
